import * as React from "react";
import { Component } from "react";

import ProgressBar from "./ProgressBar";
import { CurrentStepType, StepType } from "./types";
import withLocation from "utils/withLocation"

const matchesPath = (pattern: string, pathname: string): boolean => {
  const source = pattern
    .split("/")
    .map((segment) => {
      if (segment === "*") return ".*";
      if (segment.startsWith(":")) return "[^/]+";
      return segment.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    })
    .join("/");

  return new RegExp(`^${source}/?$`).test(pathname);
};

interface PropsType {
  location: { pathname: string };
  steps: StepType[];
}

class StepProgress extends Component<PropsType> {
  getCurrentStep(): CurrentStepType {
    const {
      location,
      steps,
    } = this.props;

    const currentStep = { index: 0, label: "" };

    for (let i = 0, l = steps.length; i < l; i++) {
      const { label, path } = steps[i];

      if (matchesPath(path || "", location.pathname)) {
        currentStep.index = i;
        currentStep.label = label;
        break;
      }
    }

    return currentStep;
  }

  render(): JSX.Element {
    const currentStep = this.getCurrentStep();
    const { steps } = this.props;

    return (
      <div id="step-progress">
        <h3>{currentStep.label}</h3>
        <ProgressBar {...{ currentStep, steps }} />
      </div>
    );
  }
}

export default withLocation(StepProgress);
